import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

export const TabPanel = (props: any) => {
  const { children, value, index, style, ...other } = props;
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={style} className={classes.container}>
          {children}
        </Box>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    paddingTop: "32px",
  },
});
